module.exports = __webpack_public_path__ + "static/img/download.2b05fc0e.jpg";